module.exports = __webpack_public_path__ + "static/img/18.c954946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/18.png
// module id = 7gLr
// module chunks = 0